import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { YearService } from '../../../shared-components/year/year.service';
// import { StudentDigitalContentService } from '../student-digital-content.service';
// import { StudentDigitalContent } from '../models/student-digital-content.model';
import { LookupService } from '../../../shared-components/lookup/lookup.service';
import { Lookup } from '../../../shared-components/lookup/lookup.model';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';

import { StudentDigitalContent } from '../../../student360/student-digital-content/models/student-digital-content.model';
import { Portfolio } from '../../../student360/portfolio/portfolio.model';
import { PortfolioService } from '../../../student360/portfolio/portfolio.service';

import { ReportingService } from '../reporting.service';
// import { AnyARecord } from 'dns';

import { DataSource } from '../models/data-source.model';
import { ConfirmArchiveReportComponent } from './confirm-archive-report.component';
import { ArchiveProcessComponent } from './archive-process.component';
import { ReportBatch } from '../models/report-batch.model';
import { LoginService } from '../../login/login.service';
import { Report } from '../models/report.model';



@Component({
    selector: 'archive-report-modal',
    templateUrl: './archive-report-modal.component.html'
})

export class ArchiveReportModalComponent implements OnInit {

    studentDigitalContent: StudentDigitalContent;
    studentPortfolio: Portfolio;

    documentTypeIdString: string;
    descriptionString: string;
    fileNameString: string;
    portfolioCategories: any[];
    fileCategoryId: number;

    newFile: boolean;
    fileError: boolean;
    documentTypes: Lookup[] = [];
    errors: ErrorList[] = [];

    selectedTCMdocument: string;
    tcmDocumentTypes: DataSource[] = [];
    reportName: string;
    batchDescription: string;
    MailServer: string;
    selectedReport: Report;
    sendEmailStudent: boolean;
    sendEmailPrimaryContact: boolean;
    sendEmailAllElectronicContacts: boolean;
    sendEmailNotification: boolean;

    emailBody = '';
    emailSubject = '';
    emailFrom = '';


    @ViewChild('fileNameInput', { read: ElementRef, static: true }) fileNameInput: ElementRef;
    @ViewChild('documentTypeInput', { read: ElementRef, static: true }) documentTypeInput: ElementRef;
    @ViewChild('fileCategoryInput', { read: ElementRef, static: true }) fileCategoryInput: ElementRef;
    @ViewChild('documentTypeTCMInput', { read: ElementRef, static: true }) documentTypeTCMInput: ElementRef;
    @ViewChild('EmailSubjectRef', { read: ElementRef }) emailSubjectRef: ElementRef;
    @ViewChild('EmailFromRef', { read: ElementRef }) emailFromRef: ElementRef;



    confirmArchiveReportDialogRef: MatDialogRef<ConfirmArchiveReportComponent>;
    archiveProcessDialogRef: MatDialogRef<ArchiveProcessComponent>;

    // @ViewChild(AddFileComponent) addFile;

    showErrorMustSelectStudent = false;
    studentInfo = '';

    archiveToStudentDigitalContent = false;
    archiveToStudentPortfolio = false;
    archiveToTCM = false;

    // archiveToStudentDigitalContent_touched = false;
    // archiveToStudentPortfolio_touched = false;
    // archiveToTCM_touched = false;

    // archiveToStudentDigitalContent_touched_count = 0;
    // archiveToStudentPortfolio_touched_count = 0;
    // archiveToTCM_touched_count = 0;

    allowArchiveToStudentDigitalContent = false;
    allowArchiveToStudentPortfolio = false;
    allowArchiveToTCM = false;

    isForSchedule: boolean;


    constructor(private yearService: YearService,
        private lookupService: LookupService,
        private portfolioService: PortfolioService,
        private reportService: ReportingService,
        private loginService: LoginService,
        @Inject(MAT_DIALOG_DATA) private data: any,
        // private studentService: StudentService,
        private dialogRef: MatDialogRef<ArchiveReportModalComponent>,
        // private confirmArchiveReportDialogRef: MatDialogRef<ArchiveReportModalComponent>,
        private confirmArchiveReportDialog: MatDialog,
        private archiveProcessDialog: MatDialog,
    ) {
        this.MailServer = this.loginService.LoginSettings.MailServer;
    }

    ngOnInit() {
        // this.studentDigitalContent = this.data.studentDigitalContent;

        this.reportName = this.reportService.SelectedReport.Name;
        this.selectedReport = this.reportService.SelectedReport;
        // this.selectedReport.EmailBody = '';
        this.emailFrom = this.selectedReport.EmailFrom;
        this.emailSubject = this.reportName;

        this.isForSchedule = false; // this.reportService.i
        this.allowArchiveToStudentDigitalContent = this.reportService.SelectedReport.AllowStudentDigitalContent;
        this.allowArchiveToStudentPortfolio = this.reportService.SelectedReport.AllowStudentPortfolio;
        this.allowArchiveToTCM = this.reportService.SelectedReport.AllowTCMArchiving;

        this.studentDigitalContent = new StudentDigitalContent;
        this.newFile = true;
        this.fileNameString = this.reportService.SelectedReport.Name;
        this.descriptionString = this.reportService.SelectedReport.Name;
        this.batchDescription = 'Archive Reports'; // this.descriptionString + ' - ' + new Date().toDateString() + ' ' + new Date().toLocaleTimeString();

        // getHours(), getMinutes(), getSeconds(), getMilliseconds()

        if (this.reportService.SelectedReport.AllowTCMArchiving) {
            this.allowArchiveToTCM = true;
            this.populate_TCM_DocumentTypes();
        }


        this.studentPortfolio = new Portfolio();

        // if (this.studentDigitalContent == undefined) {
        //     this.studentDigitalContent = new StudentDigitalContent;
        //     this.newFile = true;
        //     this.fileNameString = this.reportService.SelectedReport.Name;
        // }
        // else {
        //     this.documentTypeIdString = this.studentDigitalContent.DocumentTypeId.toString();
        //     this.descriptionString = this.studentDigitalContent.Description;
        //     this.fileNameString = this.studentDigitalContent.FileName;
        // }

        // get Document Types for Student Digital Content

        // if (this.reportService.documentTypes.length == 0) {
        this.lookupService.getORFormDocumentType(this.yearService.defaultYear.SchoolID).subscribe(result => {
            this.reportService.documentTypes = result;
            this.documentTypes = this.reportService.documentTypes;
            if (this.documentTypes.length == 0) {
                this.reportService.SelectedReport.AllowStudentDigitalContent = false;
                this.allowArchiveToStudentDigitalContent = false;
            }
        });
        // }
        // else {
        //     this.documentTypes = this.reportService.documentTypes;
        // }

        // get Portfolio Categories for Student Portfolio

        // if (this.reportService.documentTypes.length == 0) {

        this.portfolioService.getPortfolioCategories(this.reportService.currentUser.Id).subscribe(res => {
            this.portfolioCategories = res;

            if (this.portfolioCategories.length == 0) {
                this.reportService.SelectedReport.AllowStudentPortfolio = false;
                this.allowArchiveToStudentPortfolio = false;
            }

        });



        // }
        // else {
        //     this.documentTypes = this.reportService.documentTypes;
        // }


    }

    OnDestroy() { }

    populate_TCM_DocumentTypes() {

        let tcmDocumentType: DataSource;

        //  if (this.reportService.SelectedReport.AllowTCMArchiving)

        // if (this.reportService.SelectedReport.DocumentArchivePermissions.find(p => p.PrivilegeType == 'StudentAttendance')) {
        //     tcmDocumentType = new DataSource();
        //     tcmDocumentType.TextField = 'Student Attendance';
        //     tcmDocumentType.ValueField = 'TeStuAttendance';
        //     this.tcmDocumentTypes.push(tcmDocumentType);
        // }

        // if (this.reportService.SelectedReport.DocumentArchivePermissions.find(p => p.PrivilegeType == 'StudentDiscipline')) {
        //     tcmDocumentType = new DataSource();
        //     tcmDocumentType.TextField = 'Student Discipline';
        //     tcmDocumentType.ValueField = 'TeStuDiscipline';
        //     this.tcmDocumentTypes.push(tcmDocumentType);
        // }

        if (this.reportService.SelectedReport.DocumentArchivePermissions.find(p => p.PrivilegeType == 'StudentGeneral')) {
            tcmDocumentType = new DataSource();
            tcmDocumentType.TextField = 'Student General';
            tcmDocumentType.ValueField = 'TeStuGeneral'; // this is what TCM is looking for
            this.tcmDocumentTypes.push(tcmDocumentType);
        }

        if (this.reportService.SelectedReport.DocumentArchivePermissions.find(p => p.PrivilegeType == 'StudentGrades')) {
            tcmDocumentType = new DataSource();
            tcmDocumentType.TextField = 'Student Grades';
            tcmDocumentType.ValueField = 'TeStuGrades';
            this.tcmDocumentTypes.push(tcmDocumentType);
        }

        if (this.reportService.SelectedReport.DocumentArchivePermissions.find(p => p.PrivilegeType == 'StudentHealth')) {
            tcmDocumentType = new DataSource();
            tcmDocumentType.TextField = 'Student Health';
            tcmDocumentType.ValueField = 'TeStuHealth';
            this.tcmDocumentTypes.push(tcmDocumentType);
        }

        if (this.reportService.SelectedReport.DocumentArchivePermissions.find(p => p.PrivilegeType == 'StudentRegistration')) {
            tcmDocumentType = new DataSource();
            tcmDocumentType.TextField = 'Student Registration';
            tcmDocumentType.ValueField = 'TeStuRegistration';
            this.tcmDocumentTypes.push(tcmDocumentType);
        }

        if (this.reportService.SelectedReport.DocumentArchivePermissions.find(p => p.PrivilegeType == 'StudentServiceActivity')) {
            tcmDocumentType = new DataSource();
            tcmDocumentType.TextField = 'Student Service Activity';
            tcmDocumentType.ValueField = 'TeStuServiceActivity';
            this.tcmDocumentTypes.push(tcmDocumentType);
        }

        if (this.tcmDocumentTypes.length == 0) {
            this.allowArchiveToTCM = false;
        }


    }

    saveClick() {

        this.checkInputs();

        if (this.errors.length == 0) {

            // confirm they want to archive the report
            this.confirmArchiveReportDialogRef = this.confirmArchiveReportDialog.open(ConfirmArchiveReportComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true
            });

            this.confirmArchiveReportDialogRef.afterClosed().subscribe(result => {


                if (result == true) {
                    this.prepareArchiveReportAsync();
                    // this.thisDialogRef.close();
                }
            });


        } // END this.errors.length == 0

    }

    prepareArchiveReportAsync() {

        // this.selectedReport.ReportBatch.DistributeByEmailOption = '';

        // if (this.sendEmailStudent) {
        //     this.selectedReport.ReportBatch.DistributeByEmailOption = '1';
        // }

        // if (this.sendEmailPrimaryContact) {
        //     if (this.selectedReport.ReportBatch.DistributeByEmailOption > '') {
        //         this.selectedReport.ReportBatch.DistributeByEmailOption += ',2';
        //     } else {
        //         this.selectedReport.ReportBatch.DistributeByEmailOption = '2';
        //     }
        // }

        // if (this.sendEmailAllElectronicContacts) {
        //     if (this.selectedReport.ReportBatch.DistributeByEmailOption > '') {
        //         this.selectedReport.ReportBatch.DistributeByEmailOption += ',3';
        //     } else {
        //         this.selectedReport.ReportBatch.DistributeByEmailOption = '3';
        //     }
        // }

        if (this.archiveToStudentDigitalContent) {

            // START Archive To Student Digital Content *************************************

            // this.studentDigitalContent.DocumentOwnerId : set in Reports DTO
            this.studentDigitalContent.DocumentType = this.documentTypes.find(x => x.Id == this.documentTypeIdString).CodeDescription;
            this.studentDigitalContent.DocumentTypeId = parseInt(this.documentTypeIdString, 10);
            this.studentDigitalContent.Description = this.fileNameString; // this.descriptionString;
            this.studentDigitalContent.FileName = this.fileNameString + '.pdf';

            if (this.newFile) {
                this.studentDigitalContent.FileExtension = '.pdf';
                // this.studentDigitalContent.OriginalFileName = this.addFile.fileName;
                // this.studentDigitalContent.MyFileBase64String = this.addFile.fileString;  // THIS WILL BE SET IN THE BACKGROUND IN DTO
                this.studentDigitalContent.FileType = 'pdf';
                this.studentDigitalContent.FileName = this.fileNameString + '.pdf';
            }

            this.reportService.SelectedReport.StudentDigitalContent = this.studentDigitalContent;
            this.reportService.SelectedReport.ArchiveToStudentDigitalContent = true;

        } // END Archive To Student Digital Content
        else {
            this.reportService.SelectedReport.StudentDigitalContent = null;
            this.reportService.SelectedReport.ArchiveToStudentDigitalContent = false;
        }


        // START Archive to Student Portfolio **********************************************

        if (this.archiveToStudentPortfolio) {
            // this.studentPortfolio.StudentID : set in Reports DTO

            // let fileSize = window.atob(this.addFile.fileString).length;
            // let sizeUnit = 'bytes';
            // if (fileSize > 1024) {
            //     fileSize = this.roundToTwo(fileSize / 1024);
            //     sizeUnit = 'KB';
            // }
            // if (fileSize > 1000) {
            //     fileSize = this.roundToTwo(fileSize / 1024);
            //     sizeUnit = 'MB';
            // }

            // build of the portfolio object
            const portfolio: Portfolio = new Portfolio();
            portfolio.CategoryID = this.fileCategoryId;
            // portfolio.StudentID : set in DTO
            portfolio.Name = this.fileNameString + '.pdf';
            portfolio.Description = this.fileNameString; // this.descriptionString;
            // portfolio.FileBase64 = this.addFile.fileString; // set in Reports DTO
            portfolio.FilePath = this.fileNameString + '.pdf';
            portfolio.AYIdentifier = this.yearService.defaultYear.AYIdentifier;
            portfolio.AddedBy = this.reportService.currentUser.MemberId.toString();
            // portfolio.Size = fileSize;
            // portfolio.SizeUnit = sizeUnit;

            this.reportService.SelectedReport.StudentPortfolio = portfolio;
            this.reportService.SelectedReport.ArchiveToStudentPortfolio = true;

        }
        else {
            this.reportService.SelectedReport.StudentPortfolio = null;
            this.reportService.SelectedReport.ArchiveToStudentPortfolio = false;
        } // end Archive to Student Portfolio

        // START Archive To TCM *************************************

        if (this.archiveToTCM) {
            this.reportService.SelectedReport.TCM_DocumentType = this.selectedTCMdocument;
            this.reportService.SelectedReport.ArchiveToTCM = true;

        }
        else {
            this.reportService.SelectedReport.TCM_DocumentType = ''; // do I want this null?
            this.reportService.SelectedReport.ArchiveToTCM = false;
        }

        // NOW, we save any archives to the database

        if (this.archiveToStudentDigitalContent || this.archiveToStudentPortfolio || this.archiveToTCM) {

            this.reportService.SelectedReport.IsArchiveReport = true;
            this.archiveReportAsync();
        }
        else {
            this.reportService.SelectedReport.IsArchiveReport = false;
            this.reportService.SelectedReport.ArchiveToTCM = false;
            this.reportService.SelectedReport.StudentDigitalContent = null;
            this.reportService.SelectedReport.StudentPortfolio = null;
        }

        // this.dialogRef.close(true);

    }


    archiveReportAsync() {

        // this will archive to any available selected options for archiving
        // we immediately unsubscribe so it runs in background

        // TODO: UNCOMMENT SO ARCHIVIVING ACTUALLY WORKS!!!!

        // const asyncSub = this.reportService.archiveReport(this.yearService.defaultYear.SchoolID).subscribe(() => { });
        // setTimeout(() => {
        //     asyncSub.unsubscribe();
        // }, 0);

        const reportBatch: ReportBatch = new ReportBatch();
        reportBatch.Id = 0;
        reportBatch.Operations = [];
        reportBatch.AddedByName = this.reportService.getCurrentUserName_FNLN();
        reportBatch.AddedByLogin_Id = this.reportService.getCurrentUserId();
        //         reportBatch.ReportName = this.reportService.SelectedReport.Name;
        reportBatch.ReportName = this.fileNameString;
        reportBatch.BatchDescription = this.batchDescription;
        reportBatch.AddedOn = new Date();

        reportBatch.sendEmailNotification = this.sendEmailNotification;

        reportBatch.DistributeByEmailOption = '';

       // if (reportBatch.sendEmailNotification) {

            if (this.sendEmailStudent) {
                reportBatch.DistributeByEmailOption = '1';
            }

            if (this.sendEmailPrimaryContact) {
                if (reportBatch.DistributeByEmailOption > '') {
                    reportBatch.DistributeByEmailOption += ',2';
                } else {
                    reportBatch.DistributeByEmailOption = '2';
                }
            }

            if (this.sendEmailAllElectronicContacts) {
                if (reportBatch.DistributeByEmailOption > '') {
                    reportBatch.DistributeByEmailOption += ',3';
                } else {
                    reportBatch.DistributeByEmailOption = '3';
                }
            }

            reportBatch.EmailFrom = this.emailFrom;
            reportBatch.EmailSubject = this.emailSubject;
            reportBatch.EmailBody = this.emailBody;
       // }



        this.reportService.addReportBatch(reportBatch).subscribe(results => {
            // kickoff batch asynchronously
            // const asyncSub = this.reportService.startReportBatch(reportBatch).subscribe(() => { });
            // setTimeout(() => {
            //     asyncSub.unsubscribe();
            // }, 0);

            // this.openArchiveProcess();
            // if (this.reportService.inDebugMode) {
            //     console.log('here');
            //     console.log(results);
            // }

            this.reportService.reportBatch = results;


            // // kickoff batch asynchronously
            const asyncSub = this.reportService.startReportBatch(this.selectedReport).subscribe(() => { });
            setTimeout(() => {
                this.reportService.reportBatch = null;
                asyncSub.unsubscribe();
            }, 1000);



            this.openArchiveProcess();

        });


        // // kickoff batch asynchronously
        // const asyncSub = this.reportService.startReportBatch(reportBatch).subscribe(() => { });
        // setTimeout(() => {
        //     asyncSub.unsubscribe();
        // }, 0);


        // this.openArchiveProcess();

    }

    openArchiveProcess() {
        // confirm they want to archive the report
        this.archiveProcessDialogRef = this.archiveProcessDialog.open(ArchiveProcessComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            minWidth: '85vw',
            maxWidth: '100vw',
            minHeight: '85vh',
            maxHeight: '100vh'
        });

        this.archiveProcessDialogRef.afterClosed().subscribe(result => {

            // if (this.reportService.inDebugMode) {
            //     console.log(result);
            // }

            if (result == true) {



                //  this.reportService.getReportBatches();

                this.reportService.SelectedReport = null;
                this.reportService.reportBatch = null;

                this.dialogRef.close(true);
            }
        });
    }

    archiveToStudentDigitalContentChecked(isChecked: boolean) {
        this.archiveToStudentDigitalContent = isChecked;
        this.populateEmailBody();
        // this.archiveToStudentDigitalContent_touched = true;
        // this.archiveToStudentDigitalContent_touched_count += 1;
        // if (this.reportService.inDebugMode) {
        //     console.log(this.documentTypeIdString);
        // }
    }

    archiveToStudentPortfolioChecked(isChecked: boolean) {
        this.archiveToStudentPortfolio = isChecked;
        // this.archiveToStudentPortfolio_touched = true;
        // this.archiveToStudentPortfolio_touched_count += 1;
        this.populateEmailBody();


        // if (this.reportService.inDebugMode) {
        //     console.log(this.fileCategoryId);
        // }
    }

    archiveToTCMChecked(isChecked: boolean) {
        this.archiveToTCM = isChecked;
        this.populateEmailBody();
        // this.archiveToTCM_touched = true;
        // this.archiveToTCM_touched_count += 1;

        // if (this.reportService.inDebugMode) {
        //     console.log(this.selectedTCMdocument);
        // }

        // this.reportService.SelectedReport.ArchiveToTCM = this.archiveToTCM;
        // if (isChecked) {
        //     this.reportService.SelectedReport.TCM_DocumentType = this.selectedTCMdocument;
        // }
    }

    populateEmailBody() {

        if (!this.archiveToTCM && !this.archiveToStudentPortfolio && !this.archiveToStudentDigitalContent) {
            this.emailBody = '';
            return;
        }

        this.emailBody = this.selectedReport.Name + ' for student [StudentFirstName] [StudentLastName]';

        if (this.archiveToStudentPortfolio) {
            this.emailBody += ' is now available under Student Portfolio.';
        }


        // if (this.archiveToTCM && !this.archiveToStudentPortfolio && !this.archiveToStudentDigitalContent) {
        //     this.emailBody += ' is now available under Documents.';
        // }

        // if (!this.archiveToTCM && this.archiveToStudentPortfolio && !this.archiveToStudentDigitalContent) {
        //     this.emailBody += ' is now available under Student Portfolio.';
        // }

        // if (!this.archiveToTCM && !this.archiveToStudentPortfolio && this.archiveToStudentDigitalContent) {
        //     this.emailBody += ' is now available under Student Digital Content.';
        // }

        // if (!this.archiveToTCM && this.archiveToStudentPortfolio && this.archiveToStudentDigitalContent) {
        //     this.emailBody += ' is now available under Student Digital Content and Student Portfolio.';
        // }

        // if (this.archiveToTCM && !this.archiveToStudentPortfolio && this.archiveToStudentDigitalContent) {
        //     this.emailBody += ' is now available under Student Digital Content and Documents.';
        // }

        // if (this.archiveToTCM && this.archiveToStudentPortfolio && !this.archiveToStudentDigitalContent) {
        //     this.emailBody += ' is now available under Student Portfolio and Documents.';
        // }

        // if (this.archiveToTCM && this.archiveToStudentPortfolio && this.archiveToStudentDigitalContent) {
        //     this.emailBody += ' is now available under Student Digital Content, Student Portfolio, and Documents.';
        // }
    }



    checkInputs() {
        // let isValidFile = true;

        // if (this.reportService.inDebugMode) {
        //     ConsoleReporter.log();
        //     ConsoleReporter.log();
        //     ConsoleReporter.log();
        // }

        // if (
        //         (this.archiveToStudentDigitalContent && this.archiveToStudentDigitalContent_touched_count == 1 && this.documentTypeIdString == undefined) ||
        //         (this.archiveToStudentPortfolio && this.archiveToStudentPortfolio_touched_count == 1 && this.fileCategoryId == undefined) ||
        //         (this.archiveToTCM && this.archiveToTCM_touched_count == 1 && this.selectedTCMdocument == undefined)
        //  ) {
        //     return; // no need to validate yet
        // }

        this.errors = [];

        if (!this.archiveToStudentDigitalContent && !this.archiveToStudentPortfolio && !this.archiveToTCM) {
            this.errors.push({
                fieldName: '',
                fieldRef: null,
                errorMsg: 'You must select at least one archive type.'
            });
        }

        // if (this.fileNameString == undefined || this.fileNameString == null || this.fileNameString == '') {
        //     this.errors.push({
        //         fieldName: 'File Name',
        //         fieldRef: this.fileNameInput,
        //         errorMsg: 'Field is required.'
        //     });
        // }

        // if (this.archiveToStudentDigitalContent) {

        //     // START Archive To Student Digital Content



        //     if (this.documentTypeIdString == undefined || this.documentTypeIdString == null || this.documentTypeIdString == '') {
        //         this.errors.push({
        //             fieldName: 'Document Type',
        //             fieldRef: this.documentTypeInput,
        //             errorMsg: 'Field is required.'
        //         });
        //     }

        // if (this.newFile) {

        // if (this.fileNameString.length == 0) {
        //     this.fileError = true;
        //     isValidFile = false;
        // } else {
        //     this.fileError = false;
        // }

        // ANY/ALL archive options use this field

        if (this.fileNameString == undefined || this.fileNameString == null || this.fileNameString == '') {
            this.errors.push({
                fieldName: 'File Name',
                fieldRef: this.fileNameInput,
                errorMsg: 'Field is required.'
            });
        }

        if (this.archiveToStudentDigitalContent) {

            // START Archive To Student Digital Content

            if (this.documentTypeIdString == undefined || this.documentTypeIdString == null || this.documentTypeIdString == '') {
                this.errors.push({
                    fieldName: 'Student Digital Content Document Type',
                    fieldRef: this.documentTypeInput,
                    errorMsg: 'Field is required.'
                });
            }

        } // END Archive To Student Digital Content


        if (this.archiveToStudentPortfolio) {

            // START Archive To Student Portfolio

            if (this.fileCategoryId == undefined || this.fileCategoryId == null || !(this.fileCategoryId > 0)) {
                this.errors.push({
                    fieldName: 'Student Portfolio Document Type',
                    fieldRef: this.fileCategoryInput,
                    errorMsg: 'Field is required.'
                });
            }

        } // END Archive To Student Digital Content

        if (this.archiveToTCM) {

            // START TCM -- Tyler Content Management

            if (this.selectedTCMdocument == undefined || this.selectedTCMdocument == null || this.selectedTCMdocument == '') {
                this.errors.push({
                    fieldName: 'TCM Document Type',
                    fieldRef: this.documentTypeTCMInput,
                    errorMsg: 'Field is required.'
                });
            }
        }

        this.validateEmailFields();




        // }

        // for ALL archive options

        // if (this.fileNameString.length == 0) {
        //     this.fileError = true;
        //     isValidFile = false;
        // } else {
        //     this.fileError = false;
        // }


        // if (!isValidFile) {
        //     this.errors.push({
        //         fieldName: 'File',
        //         fieldRef: this.fileNameInput,
        //         errorMsg: 'Field is required.'
        //     });
        // }


    } // end checkInputs()

    validateEmailFields() {
        if (this.sendEmailNotification && !this.sendEmailStudent && !this.sendEmailPrimaryContact && !this.sendEmailAllElectronicContacts) {
            this.errors.push({
                fieldName: null,
                fieldRef: null,
                errorMsg: 'You must select at least one option for Send emails to.'
            });
        }


        /********************* START EMAIL SUBJECT VALIDATION  *********************/

        // Email Subject required
        if (this.sendEmailNotification && this.selectedReport.EmailSubject.trim().length == 0) {
            this.errors.push({
                fieldName: 'Email Subject',
                fieldRef: this.emailSubjectRef,
                errorMsg: 'Required Field'
            });
        }


        /********************* START EMAIL FROM VALIDATION  *********************/

        const emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
        // const emailsTo: string[] = this.selectedReport.EmailsToSendReport.replace(' ', '').split(';');

        // // remove final empty string from split
        // if (emailsTo.length > 1) {
        //   if (emailsTo[emailsTo.length - 1] == '') {
        //     emailsTo.length = emailsTo.length - 1;
        //   }
        // }

        // Email From required -- FIRST MESSAGE
        if (this.selectedReport.EmailFrom.trim().length == 0) {

            this.errors.push({
                fieldName: 'Email From',
                errorMsg: 'Required field.',
                fieldRef: this.emailFromRef
            });

            // if (this.inDebugMode) {
            //   console.log('this.selectedReport.EmailFrom.trim().length');
            //   console.log(this.selectedReport.EmailFrom.trim().length);
            // }
        }
        else {

            // errorMsg: this.selectedReport.EmailFrom.trim() + ' is not a valid email format',

            // check Email From format -- SECOND MESSAGE
            if (this.selectedReport.EmailFrom.trim().match(emailFormat) == null) {
                this.errors.push({
                    fieldName: 'Email From',
                    errorMsg: 'Invalid email address.',
                    fieldRef: this.emailFromRef
                });

            }

            else {

                // check Email From is a single email -- THIRD MESSAGE
                if (this.selectedReport.EmailFrom.split(';').length > 1) {

                    this.errors.push({
                        fieldName: 'Email From',
                        errorMsg: 'Must be a single email.',
                        fieldRef: this.emailFromRef
                    });

                }
            }

            // if (this.inDebugMode) {
            //   console.log('this.selectedReport.EmailFrom.trim().match(emailFormat)');
            //   console.log(this.selectedReport.EmailFrom.trim().match(emailFormat));
            // }

        }

    }

    // addFileChanges(event) {
    //     // check if a file has been selected
    //     if (this.addFile.hasOwnProperty('fileName')) {
    //         this.fileError = false;
    //     }
    // }

    getEmailRegexp() {
        return this.reportService.getEmailRegexp();
    }

    sendToEmailChecked(isChecked: boolean) {

        // right now the only errors being handled are for report to email
        // so clear them out if they uncheck the checkbox
        if (!isChecked) {
            this.errors = [];
        }
    }


    closeClick() {
        this.reportService.SelectedReport.IsArchiveReport = false;
        this.reportService.SelectedReport.ArchiveToTCM = false;
        this.reportService.SelectedReport.ArchiveToStudentDigitalContent = false;
        this.reportService.SelectedReport.ArchiveToStudentDigitalContent = false;
        this.reportService.SelectedReport.StudentDigitalContent = null;
        this.reportService.SelectedReport.StudentPortfolio = null;
        this.dialogRef.close(false);
    }
}
